import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { formatNumberAmount } from "../../helpers/format";
import { paymentStatusMap } from "../../helpers/mapping";

const PaymentBox = ({ paymentStatus, label, amount, padding = 1 }) => {
    const theme = useTheme();
    const paymentStatusItems = paymentStatusMap();
    const paymentStatusSelected = paymentStatusItems[paymentStatus] ?? paymentStatusItems["BLANK"];
    const color = paymentStatusSelected.color;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: theme.palette[color].main,
                color: theme.palette[color].contrastText,
                padding: theme.spacing(padding),
                fontSize: "0.8rem",
                gap: theme.spacing(0.7),
            }}
        >
            <Box>
                <Typography sx={{fontWeight: "bold", textAlign: "center"}}>{label}</Typography>
            </Box>
            <Box>
                <Typography  sx={{textAlign: "center"}}>{formatNumberAmount(amount)}</Typography>
            </Box>
        </Box>
    )
}

export default PaymentBox;
